import styled from 'styled-components'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'
import { APPLICATION, CATEGORY } from '../../../constants/Constants'
import { FilterHeader, FilterNameBold, FilterName } from '../../../css/Style'

interface FilterWithSearchProps {
  title: string;
  filterNameArr: string[];
  filterOnClickAction: (useCase?: string, categories?: string, applications?: string) => void;
  appliedFilterName?: string | null;
}

const CategoriesContainer = styled.div`
padding-right: 20px;
margin-top: 40px;
height: 300px;
`

const FilterValues = styled.div`
overflow-y: auto;
height: 220px;
padding-bottom: 4px;
margin-left: 20px;
`

const FilterWithSearch: React.FunctionComponent<FilterWithSearchProps> = ({
  filterNameArr,
  title,
  filterOnClickAction,
  appliedFilterName
}) => {
  const [filtersAfterSearch, setFiltersAfterSearch] = useState(filterNameArr)

  const onSearchChange = (searchValue: string) => {
    setFiltersAfterSearch(filterNameArr.filter((filterName) => filterName.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())))
  }

  const callFilterClick = (filterName: string, filterTitle: string) => {
    if (filterTitle === CATEGORY) {
      filterOnClickAction(undefined, filterName, undefined)
    } else if (filterTitle === APPLICATION) {
      filterOnClickAction(undefined, undefined, filterName)
    }
  }
  return (
    <CategoriesContainer>
      <FilterHeader>{title}</FilterHeader>
      <TextField
        margin="normal"
        variant="outlined"
        placeholder={'Search'}
        InputProps={{
          type: 'search',
          startAdornment: (
            <InputAdornment position="start" style={{ color: '#aaa' }}>
              <SearchOutlinedIcon
                style={{
                  height: '16px',
                  width: '16px'
                }} />
            </InputAdornment>
          ),
          style: {
            height: '44px'
          }
        }}
        inputProps={{
          style: {
            fontSize: '14px'
          }
        }}
        style={{
          backgroundColor: 'white',
          display: 'flex',
          height: '44px',
          paddingRight: '15px'
        }}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <FilterValues>
        {
          filtersAfterSearch.map((filterName) => {
            return filterName === appliedFilterName
              ? <FilterNameBold key={filterName} onClick={() => callFilterClick(filterName, title)}>{filterName}
              </FilterNameBold>
              : <FilterName key={filterName} onClick={() => callFilterClick(filterName, title)}>{filterName}
              </FilterName>
          })
        }
      </FilterValues>
    </CategoriesContainer>
  )
}

export default FilterWithSearch
